import { toast } from "react-toastify";

const capitalizeWords = (str) => {
  if (!str || typeof str !== "string") return "";
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

const showToast = (type, message, duration = 3000) => {
  const capitalizedMessage = capitalizeWords(message);

  const options = {
    position: "top-right",
    autoClose: duration,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    closeButton: false,
  };

  switch (type) {
    case "success":
      toast.success(capitalizedMessage, options);
      break;
    case "error":
      toast.error(capitalizedMessage, { ...options, autoClose: 10000 });
      break;
    case "info":
      toast.info(capitalizedMessage, options);
      break;
    case "warn":
      toast.warn(capitalizedMessage, options);
      break;
    default:
      toast(capitalizedMessage, options);
  }
};

// Exported convenience wrappers
export const showSuccessToast = (msg) => showToast("success", msg);
export const showErrorToast = (msg) => showToast("error", msg);
export const showInfoToast = (msg) => showToast("info", msg);
export const showWarningToast = (msg) => showToast("warn", msg);
